import { CustomElement } from "../../../core/CustomElement";

import "../input-text/index";
import { CCCInputText } from "../input-text/index";
import "../../icon";
import { CCCIcon } from "../../icon";

import "../../calendar/index";
import { CCCEventCalendar } from "../../calendar/index";
import DatePickerVM from "./viewModel";

/**
 * Cccdate picker
 */
export class CCCDatePicker extends CustomElement {
  // eslint-disable-next-line
  state: any = {};
  viewModel: DatePickerVM = null;

  $cccInput: CCCInputText = null;
  $cccIcon: CCCIcon = null;
  $calendarDiv: HTMLElement = null;
  preventBlur = false;
  pickerInitiated = false;
  $picker: CCCEventCalendar = null;

  /**
   * Gets observed attributes
   */
  // eslint-disable-next-line
  static get observedAttributes() {
    return ["label", "date-format", "min-date", "max-date", "disabled"];
  }

  /**
   * Creates an instance of cccdate picker.
   */
  constructor() {
    super();
    this.templateConfig = {
      template: require("./template.html").default,
      style: require("./style.scss").default,
      viewModel: require("./viewModel"),
    };
    this.setupComponent();
    this.$cccInput = this.shadowDom.querySelector("ccc-input-text");
    this.$cccIcon = this.shadowDom.querySelector("ccc-icon");
    this.$calendarDiv = this.shadowDom.querySelector(".calendar");
    this.$picker = this.shadowDom.querySelector("#picker");

    this.setUpCalendarLogic();
  }

  /**
   * Sets up calendar display logic and event for calendar date picked.
   */
  // eslint-disable-next-line
  setUpCalendarLogic() {
    //this.$picker.init();
    this.addEventListener("focus", () => {
      // display the calendar
      this.toggleCalendarDisplay();
      if (!this.pickerInitiated) {
        /**
         * initiate calendar in case it wasn't
         * needs to be done at the moment of showing div for the calendar to
         * properly get the space available and render properly
         */
        this.pickerInitiated = true;
        this.$picker.init();
      }
    });
    // eslint-disable-next-line
    this.addEventListener("blur", (e) => {
      // sometimes we don't want to hide the calendar
      if (!this.preventBlur) {
        this.toggleCalendarDisplay();
      } else {
        // reset flag so we hide next time
        this.preventBlur = false;
      }
    });

    //this.$picker.init();
    // eslint-disable-next-line
    this.$picker.onDateSelected((date: string) => {
      // Set date value on VM
      this.viewModel.dateSelected(date);
      // set date value formatted on input
      this.$cccInput.setValue(this.viewModel.dateSelectedFormated());
      // prevent blur event since it will open the calendar again
      this.preventBlur = true;
      // close the calendar
      this.toggleCalendarDisplay();
      // dispatch the blur event just to refresh the state of the input if user needs to click again to show calendar
      this.blur();
    });
  }

  /**
   * Toggles calendar display
   */
  // eslint-disable-next-line
  toggleCalendarDisplay() {
    console.log("calendar display", this.$calendarDiv.classList);
    if (this.$calendarDiv.classList.contains("show")) {
      this.$calendarDiv.classList.remove("show");
    } else {
      this.$calendarDiv.classList.add("show");
    }
  }

  /**
   * Attributes changed callback
   * @param attr
   * @param oldValue
   * @param newValue
   */
  // eslint-disable-next-line
  attributeChangedCallback(attr: string, oldValue: string, newValue: string) {
    if (attr == "label") {
      this.$cccInput.setAttribute("label", newValue);
    }

    if (attr == "min-date") {
      this.setKeyState("minDate", newValue);
    }

    if (attr == "max-date") {
      this.setKeyState("maxDate", newValue);
    }

    if (attr == "disabled") {
      if (newValue === null) {
        this.$cccInput.removeAttribute("disabled");
        this.$cccIcon.classList.remove("disabled");
      } else {
        this.$cccInput.setAttribute("disabled", "");
        this.$cccIcon.classList.add("disabled");
      }
    }
  }

  // eslint-disable-next-line
  subscribeToVal(fn: Function) {
    this.viewModel.subscribeToValue(fn);
  }

  /**
   * Watchs state minDate
   */
  // eslint-disable-next-line
  watchMinDate() {
    this.$picker.setKeyState("minDate", this.state.minDate);
  }

  /**
   * Watchs state maxDate
   */
  // eslint-disable-next-line
  watchMaxDate() {
    this.$picker.setKeyState("maxDate", this.state.maxDate);
  }

  public get value(): string {
    return this.$cccInput.getValue();
  }

  public set value(value: string) {
    this.$cccInput.setValue(value);
  }
}

// define component
if (!customElements.get("ccc-date-picker")) {
  customElements.define("ccc-date-picker", CCCDatePicker);
}
